<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="listQuery.name"
        placeholder="请输入学生姓名"
        style="width: 150px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已冻结" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <div class="filter-container" style="">
      <el-button class="filter-item" type="primary" @click="download">
        导出学生模板
      </el-button>

      <el-upload
        class="upload-demo"
        style="margin-left: 10px"
        accept=".xlsx,.xls"
        action=""
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleImportOrders"
      >
        <el-button
          class="filter-item"
          type="warning"
          icon="el-icon-upload"
          :disabled="listQuery.school_id ? false : true"
        >
          导入学生
        </el-button>
      </el-upload>

      <download-excel
        :fields="student_fields"
        :fetch="handleExport"
        type="xls"
        :name="'学生名单.xls'"
        worksheet="学生名单"
        header="学生名单"
      >
        <el-button class="filter-item" style="margin-left: 10px" type="success">
          下载学生名单
        </el-button>
      </download-excel>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @sort-change="changeSort"
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学生姓名" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.name }} </template>
      </el-table-column>
      <el-table-column label="账号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.account }} </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.phone }} </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center" sortable>
        <template slot-scope="scope">
          {{ scope.row.college.school.name }}
        </template>
      </el-table-column>
      <el-table-column label="院系" min-width="110" align="center" sortable>
        <template slot-scope="scope">
          {{ scope.row.college.name }}
        </template>
      </el-table-column>
      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.new_class_student
              ? scope.row.new_class_student.classes.major.name
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="年级" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.new_class_student
              ? scope.row.new_class_student.classes.grade.name
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope"
          >{{
            scope.row.new_class_student
              ? scope.row.new_class_student.classes.name
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="学年" min-width="110" align="center">
        <template slot-scope="scope" v-if="scope.row.new_class_student">
          {{ scope.row.new_class_student.classes.school_year }}
          ~
          {{ scope.row.new_class_student.classes.school_year - 0 + 1 }}
        </template>
        <template v-else> - </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_normal == 1"> 正常 </el-tag>
          <el-tag type="danger" v-else>已冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '冻结')"
            v-if="scope.row.is_normal == 1"
            >冻结</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '解冻')"
            v-else
            >解冻</el-button
          > -->
          <!-- <el-button
            size="mini"
            style="margin-top: 10px"
            type="warning"
            @click="initializationPassword(scope.row.id, '初始化')"
            >初始化密码</el-button
          > -->
          <el-button
            size="mini"
            style="margin-top: 10px"
            type="primary"
            @click="handleClass(scope.row)"
            >查看课表</el-button
          >
          <el-button
            v-if="scope.row.is_auth > 0"
            size="mini"
            style="margin-top: 10px"
            type="danger"
            @click="deleteHandler(scope.row)"
            >解绑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="导入数据预览"
      :visible.sync="importDataDialogVisible"
      center
      width="60%"
      :close-on-click-modal="false"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 500px">
          <el-table :data="yulanData" style="width: 1100px">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.index || '' }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="学校" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.school_name || "" }}
              </template>
            </el-table-column> -->
            <el-table-column label="院系" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.college_name || '' }}
              </template>
            </el-table-column>
            <el-table-column label="学生名称" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.name || '' }}
              </template>
            </el-table-column>
            <el-table-column label="性别" min-width="60" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.sex == 1
                    ? '男'
                    : scope.row.sex == 2
                    ? '女'
                    : '未设置'
                }}
              </template>
            </el-table-column>
            <el-table-column label="出生年月" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.birth_info || '' }}
              </template>
            </el-table-column>
            <el-table-column label="入学时间" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.entrance_at || '' }}
              </template>
            </el-table-column>
            <el-table-column label="学生学号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.account }}
              </template>
            </el-table-column>
            <el-table-column label="学生联系电话" min-width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.phone }}
              </template>
            </el-table-column>
            <el-table-column label="家长姓名" min-width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.parent_name }}
              </template>
            </el-table-column>
            <el-table-column label="家长联系电话" min-width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.parent_phone }}
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importDataDialogVisible = false">取消</el-button>
        <el-button @click="importSaveData" type="primary" :loading="btnLoading"
          >确认导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
import { excel2Json } from '@/utils/excel'
import moment from 'moment'
export default {
  components: { downloadExcel },
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      schools: [],
      grades: [],
      yulanData: [],
      school_id: null,
      school_year: null,
      listQuery: {
        page: 1,
        limit: 10,
        school: '',
        status: '',
        name: '',
        school_name_sort: '',
        college_name_sort: '',
        // major_name_sort: "",
      },
      dialogFormVisible: false,
      importDataDialogVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增',
      },
      form: {
        id: '',
        school_year: '',
        grade_id: '',
        college_id: '',
        major_id: '',
        class_id: '',
        name: '',
        account: '',
        phone: '',
      },
      rules: {
        school_year: [
          { required: true, message: '学年不能为空', trigger: 'change' },
        ],
        grade_id: [
          { required: true, message: '年级不能为空', trigger: 'change' },
        ],
        college_id: [
          { required: true, message: '院系不能为空', trigger: 'change' },
        ],
        major_id: [
          { required: true, message: '专业不能为空', trigger: 'change' },
        ],
        class_id: [
          { required: true, message: '班级不能为空', trigger: 'change' },
        ],
        name: [
          { required: true, message: '学生姓名不能为空', trigger: 'change' },
        ],
        account: [
          { required: true, message: '学生账号不能为空', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '到期时间不能为空', trigger: 'change' },
        ],
      },
      colleges: [],
      majors: [],
      classes: [],
      grades: [{ id: 1, name: '年级1' }],
      departments: [{ id: 1, name: '院系1' }],
      professionals: [{ id: 1, name: '专业1' }],
      banjis: [{ id: 1, name: '班级1' }],
      btnLoading: false,
      //导出学生花名册
      student_fields: {
        序号: 'index',
        '入学时间(格式:xxxx/xx/xx)': 'entrance_at',
        '院系（请认证核对管理系统相关院系）': 'college_name',
        专业: 'new_class_student.classes.major.name',
        年级: 'new_class_student.classes.grade.name',
        班级: 'new_class_student.name',
        学年: 'new_class_student.school_year',
        学生名称: 'name',
        性别: {
          field: 'sex',
          //自定义回调函数
          callback: (value) => {
            let val = ''
            if (value == 1) {
              val = '男'
            } else {
              val = '女'
            }
            return '<p style="mso-number-format:\'\\@\';">' + val + '</p>'
          },
        },
        出生年月: {
          field: 'birth_info',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        学生学号: {
          field: 'account',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        学生联系电话: 'phone',
        家长姓名: 'parent_name',
        家长联系电话: 'parent_phone',
      },
    }
  },
  created() {
    this.getSchoolList()
    this.getList()
  },
  methods: {
    handleExport() {
      this.listQuery.limit = 99999999999999
      return request({
        url: '/api/backend/student/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((result) => {
          console.log(result.data.data)
          var json_data = result.data.data
          json_data.forEach((element, index) => {
            element.index = index + 1
          })
          // console.log(json_data[0].classes.college.school.name);
          this.listQuery.limit = 10
          // this.header =
          //   json_data[0].classes.college.school.name +
          //   json_data[0].classes.college.name +
          //   json_data[0].classes.major.name +
          //   json_data[0].classes.grade.name +
          //   json_data[0].classes.name;
          return json_data
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    //下载模板
    download() {
      window.open(
        'https://img.jcqjmk.com/学生信息导入模板.xlsx?attname=学生信息导入模板.xlsx',
        '_parent'
      )
    },
    handleImportOrders(file) {
      if (!this.listQuery.school_id) {
        return
      }
      console.log(1111)
      this.yulanData = []
      file = file.raw
      if (
        !(file.name.split('.')[1] == 'xlsx' || file.name.split('.')[1] == 'xls')
      ) {
        this.$message.error('上传文件格式不正确，请检查选择的文件')
        return
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData)
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error('数据不能为空')
          return
        }
        excelData.forEach((element, index) => {
          console.log(element, '--------', index)
          if (index > 0) {
            this.yulanData.push({
              index: index,
              entrance_at:
                moment(
                  element['__EMPTY'] * 24 * 60 * 60 * 1000 +
                    Date.parse('1899-12-30')
                ).format('YYYY-MM-DD') || '',
              // school_name: element["__EMPTY_1"] || "",
              college_name: element['__EMPTY_1'] || '',
              name: element['__EMPTY_2'] || '',
              sex: element['__EMPTY_3'] == '男' ? 1 : 2,
              birth_info:
                element['__EMPTY_4'] > 0
                  ? moment(
                      element['__EMPTY_4'] * 24 * 60 * 60 * 1000 +
                        Date.parse('1899-12-30')
                    ).format('YYYY-MM') || ''
                  : element['__EMPTY_4'],
              account: element['__EMPTY_5'] + '' || '',
              phone: element['__EMPTY_6'] || '',
              parent_name: element['__EMPTY_7'] || '',
              parent_phone: element['__EMPTY_8'] || '',
            })
          }
        })
        this.importDataDialogVisible = true
      })
      console.log(this.yulanData, '=============')
    },
    importSaveData() {
      for (let index = 0; index < this.yulanData.length; index++) {
        const item = this.yulanData[index]
        for (var key in item) {
          if (!item[key]) {
            this.$message({
              type: 'error',
              message: '请完善数据!!',
            })
            return
          }
        }
      }
      // return;
      request({
        url: '/api/backend/student/importStudent',
        method: 'post',
        data: {
          students: this.yulanData,
          is_confirm: false,
          school_id: this.listQuery.school_id,
        },
      })
        .then((response) => {
          console.log(response)
          this.btnLoading = false
          this.importDataDialogVisible = false
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
        .catch((err) => {
          this.btnLoading = false
          this.$alert(err.msg, '提示', {
            confirmButtonText: '确定',
            callback: (action) => {
              request({
                url: '/api/backend/student/importStudent',
                method: 'post',
                data: {
                  students: this.yulanData,
                  is_confirm: true,
                  school_id: this.listQuery.school_id,
                },
              }).then((res) => {
                this.btnLoading = false
                this.importDataDialogVisible = false
                this.getList()
                this.$message({
                  type: 'success',
                  message: '操作成功!',
                })
              })
            },
          })
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    //排序
    changeSort(e) {
      console.log(e)
      this.listQuery.school_name_sort = ''
      this.listQuery.college_name_sort = ''
      // this.listQuery.major_name_sort = "";
      if (e.order == null) {
        this.getList()
        return
      }
      switch (e.column.label) {
        case '学校':
          if (e.order == 'ascending') {
            this.listQuery.school_name_sort = 0
          } else {
            this.listQuery.school_name_sort = 1
          }
          break
        case '院系':
          if (e.order == 'ascending') {
            this.listQuery.college_name_sort = 0
          } else {
            this.listQuery.college_name_sort = 1
          }
          break
        // case "专业":
        //   if (e.order == "ascending") {
        //     this.listQuery.major_name_sort = 0;
        //   } else {
        //     this.listQuery.major_name_sort = 1;
        //   }
        //   break;
        default:
          break
      }
      this.getList()
    },
    handleClass(row) {
      this.$router.push(
        `/student/class_schedule?class_id=${row.new_class_student.class_id}&student_id=${row.new_class_student.student_id}`
      )
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/student/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getSchoolList() {
      request({
        url: '/api/backend/school/list',
        method: 'get',
        params: {
          limit: 99999999999999,
        },
      }).then((response) => {
        this.schools = response.data.data
      })
    },
    //初始化密码
    initializationPassword(v, text) {
      this.$confirm('此操作将该学生密码' + text + ', 是否继续?', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/school/classStudentInitPassword',
            method: 'post',
            data: { id: v },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    getGradeList() {
      request({
        url: '/api/backend/school/gradeList',
        method: 'get',
        params: {
          limit: 999999999999999,
          school_year: this.form.school_year,
          school_id: this.school_id,
        },
      }).then((response) => {
        this.grades = response.data.data
      })
    },
    // getGradeList() {
    //   request({
    //     url: "/api/backend/school/gradeList",
    //     method: "get",
    //     params: {
    //       limit: 999999999999999,
    //       school_year: this.form.school_year,
    //       school_id: this.school_id,
    //     },
    //   }).then((response) => {
    //     this.grades = response.data.data;
    //   });
    // },
    getCollegeList() {
      request({
        url: '/api/backend/school/collegeList',
        method: 'get',
        params: {
          limit: 999999999999999,
          school_id: this.school_id,
        },
      }).then((response) => {
        this.colleges = response.data.data
      })
    },
    getMajorList() {
      request({
        url: '/api/backend/school/majorList',
        method: 'get',
        params: {
          limit: 999999999999999,
          college_id: this.form.college_id,
        },
      }).then((response) => {
        this.majors = response.data.data
      })
    },
    getClassList() {
      request({
        url: '/api/backend/school/classList',
        method: 'get',
        params: {
          limit: 999999999999999,
          grade_id: this.form.grade_id,
          major_id: this.form.major_id,
          school_id: this.school_id,
          school_year: this.form.school_year,
        },
      }).then((response) => {
        this.classes = response.data.data
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: '',
        name: '',
      }
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.school_id = row.classes.college.school_id
      this.resetForm()
      this.form = {
        id: row.id,
        school_year: row.classes.grade.school_year,
        grade_id: row.classes.grade_id,
        college_id: row.classes.college_id,
        major_id: row.classes.major_id,
        class_id: row.class_id,
        name: row.student.name,
        account: row.student.account,
        phone: row.student.phone,
        student_id: row.student_id,
      }
      this.getGradeList()
      this.getCollegeList()
      this.getMajorList()
      this.getClassList()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/school/classStudentStore',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm('此操作将' + text + '该学生, 是否继续?', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/school/classStudentchangeNormal',
            method: 'post',
            data: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    async deleteHandler(data) {
      try {
        console.log(data)
        await this.$confirm('此操作将解绑认证用户, 是否继续?', '警告', {
          type: 'warning',
        })
        await request({
          url: '/api/backend/student/unbindAuthUser',
          method: 'post',
          data: { student_id: data.id },
        })
        this.$message({ message: '解绑认证用户成功!', type: 'success' })
        this.getList()
      } catch (err) {}
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
}
</style>
